import React, {useContext} from "react";
import { Route, Redirect } from "react-router-dom";
import AuthContext from 'context/AuthProvider';

export const ProtectedRoute = ({
  component: Component,
  ...rest
}) => {
    const authContext = useContext(AuthContext);
    return (
        <Route
        {...rest}
        render={props => {
            if (authContext.isAuthenticated()) {
            return <Component {...props} />;
            } else {
            return (
                <Redirect
                to={{
                    pathname: "/",
                    state: {
                    from: props.location
                    }
                }}
                />
            );
            }
        }}
        />
    );
};